webpackJsonp([35783957827783],{

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var emptyObject = __webpack_require__(34);
	var _invariant = __webpack_require__(1);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var formatter = __webpack_require__(304)
	
	var fault = create(Error)
	
	module.exports = fault
	
	fault.eval = create(EvalError)
	fault.range = create(RangeError)
	fault.reference = create(ReferenceError)
	fault.syntax = create(SyntaxError)
	fault.type = create(TypeError)
	fault.uri = create(URIError)
	
	fault.create = create
	
	/* Create a new `EConstructor`, with the formatted
	 * `format` as a first argument. */
	function create(EConstructor) {
	  FormattedError.displayName = EConstructor.displayName || EConstructor.name
	
	  return FormattedError
	
	  function FormattedError(format) {
	    if (format) {
	      format = formatter.apply(null, arguments)
	    }
	
	    return new EConstructor(format)
	  }
	}


/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	//
	// format - printf-like string formatting for JavaScript
	// github.com/samsonjs/format
	// @_sjs
	//
	// Copyright 2010 - 2013 Sami Samhuri <sami@samhuri.net>
	//
	// MIT License
	// http://sjs.mit-license.org
	//
	
	;(function() {
	
	  //// Export the API
	  var namespace;
	
	  // CommonJS / Node module
	  if (true) {
	    namespace = module.exports = format;
	  }
	
	  // Browsers and other environments
	  else {
	    // Get the global object. Works in ES3, ES5, and ES5 strict mode.
	    namespace = (function(){ return this || (1,eval)('this') }());
	  }
	
	  namespace.format = format;
	  namespace.vsprintf = vsprintf;
	
	  if (typeof console !== 'undefined' && typeof console.log === 'function') {
	    namespace.printf = printf;
	  }
	
	  function printf(/* ... */) {
	    console.log(format.apply(null, arguments));
	  }
	
	  function vsprintf(fmt, replacements) {
	    return format.apply(null, [fmt].concat(replacements));
	  }
	
	  function format(fmt) {
	    var argIndex = 1 // skip initial format argument
	      , args = [].slice.call(arguments)
	      , i = 0
	      , n = fmt.length
	      , result = ''
	      , c
	      , escaped = false
	      , arg
	      , tmp
	      , leadingZero = false
	      , precision
	      , nextArg = function() { return args[argIndex++]; }
	      , slurpNumber = function() {
	          var digits = '';
	          while (/\d/.test(fmt[i])) {
	            digits += fmt[i++];
	            c = fmt[i];
	          }
	          return digits.length > 0 ? parseInt(digits) : null;
	        }
	      ;
	    for (; i < n; ++i) {
	      c = fmt[i];
	      if (escaped) {
	        escaped = false;
	        if (c == '.') {
	          leadingZero = false;
	          c = fmt[++i];
	        }
	        else if (c == '0' && fmt[i + 1] == '.') {
	          leadingZero = true;
	          i += 2;
	          c = fmt[i];
	        }
	        else {
	          leadingZero = true;
	        }
	        precision = slurpNumber();
	        switch (c) {
	        case 'b': // number in binary
	          result += parseInt(nextArg(), 10).toString(2);
	          break;
	        case 'c': // character
	          arg = nextArg();
	          if (typeof arg === 'string' || arg instanceof String)
	            result += arg;
	          else
	            result += String.fromCharCode(parseInt(arg, 10));
	          break;
	        case 'd': // number in decimal
	          result += parseInt(nextArg(), 10);
	          break;
	        case 'f': // floating point number
	          tmp = String(parseFloat(nextArg()).toFixed(precision || 6));
	          result += leadingZero ? tmp : tmp.replace(/^0/, '');
	          break;
	        case 'j': // JSON
	          result += JSON.stringify(nextArg());
	          break;
	        case 'o': // number in octal
	          result += '0' + parseInt(nextArg(), 10).toString(8);
	          break;
	        case 's': // string
	          result += nextArg();
	          break;
	        case 'x': // lowercase hexadecimal
	          result += '0x' + parseInt(nextArg(), 10).toString(16);
	          break;
	        case 'X': // uppercase hexadecimal
	          result += '0x' + parseInt(nextArg(), 10).toString(16).toUpperCase();
	          break;
	        default:
	          result += c;
	          break;
	        }
	      } else if (c === '%') {
	        escaped = true;
	      } else {
	        result += c;
	      }
	    }
	    return result;
	  }
	
	}());


/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

	/*
	Syntax highlighting with language autodetection.
	https://highlightjs.org/
	*/
	
	(function(factory) {
	
	  // Find the global object for export to both the browser and web workers.
	  var globalObject = typeof window === 'object' && window ||
	                     typeof self === 'object' && self;
	
	  // Setup highlight.js for different environments. First is Node.js or
	  // CommonJS.
	  if(true) {
	    factory(exports);
	  } else if(globalObject) {
	    // Export hljs globally even when using AMD for cases when this script
	    // is loaded with others that may still expect a global hljs.
	    globalObject.hljs = factory({});
	
	    // Finally register the global hljs with AMD.
	    if(typeof define === 'function' && define.amd) {
	      define([], function() {
	        return globalObject.hljs;
	      });
	    }
	  }
	
	}(function(hljs) {
	  // Convenience variables for build-in objects
	  var ArrayProto = [],
	      objectKeys = Object.keys;
	
	  // Global internal variables used within the highlight.js library.
	  var languages = {},
	      aliases   = {};
	
	  // Regular expressions used throughout the highlight.js library.
	  var noHighlightRe    = /^(no-?highlight|plain|text)$/i,
	      languagePrefixRe = /\blang(?:uage)?-([\w-]+)\b/i,
	      fixMarkupRe      = /((^(<[^>]+>|\t|)+|(?:\n)))/gm;
	
	  var spanEndTag = '</span>';
	
	  // Global options used when within external APIs. This is modified when
	  // calling the `hljs.configure` function.
	  var options = {
	    classPrefix: 'hljs-',
	    tabReplace: null,
	    useBR: false,
	    languages: undefined
	  };
	
	
	  /* Utility functions */
	
	  function escape(value) {
	    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	  }
	
	  function tag(node) {
	    return node.nodeName.toLowerCase();
	  }
	
	  function testRe(re, lexeme) {
	    var match = re && re.exec(lexeme);
	    return match && match.index === 0;
	  }
	
	  function isNotHighlighted(language) {
	    return noHighlightRe.test(language);
	  }
	
	  function blockLanguage(block) {
	    var i, match, length, _class;
	    var classes = block.className + ' ';
	
	    classes += block.parentNode ? block.parentNode.className : '';
	
	    // language-* takes precedence over non-prefixed class names.
	    match = languagePrefixRe.exec(classes);
	    if (match) {
	      return getLanguage(match[1]) ? match[1] : 'no-highlight';
	    }
	
	    classes = classes.split(/\s+/);
	
	    for (i = 0, length = classes.length; i < length; i++) {
	      _class = classes[i]
	
	      if (isNotHighlighted(_class) || getLanguage(_class)) {
	        return _class;
	      }
	    }
	  }
	
	  function inherit(parent) {  // inherit(parent, override_obj, override_obj, ...)
	    var key;
	    var result = {};
	    var objects = Array.prototype.slice.call(arguments, 1);
	
	    for (key in parent)
	      result[key] = parent[key];
	    objects.forEach(function(obj) {
	      for (key in obj)
	        result[key] = obj[key];
	    });
	    return result;
	  }
	
	  /* Stream merging */
	
	  function nodeStream(node) {
	    var result = [];
	    (function _nodeStream(node, offset) {
	      for (var child = node.firstChild; child; child = child.nextSibling) {
	        if (child.nodeType === 3)
	          offset += child.nodeValue.length;
	        else if (child.nodeType === 1) {
	          result.push({
	            event: 'start',
	            offset: offset,
	            node: child
	          });
	          offset = _nodeStream(child, offset);
	          // Prevent void elements from having an end tag that would actually
	          // double them in the output. There are more void elements in HTML
	          // but we list only those realistically expected in code display.
	          if (!tag(child).match(/br|hr|img|input/)) {
	            result.push({
	              event: 'stop',
	              offset: offset,
	              node: child
	            });
	          }
	        }
	      }
	      return offset;
	    })(node, 0);
	    return result;
	  }
	
	  function mergeStreams(original, highlighted, value) {
	    var processed = 0;
	    var result = '';
	    var nodeStack = [];
	
	    function selectStream() {
	      if (!original.length || !highlighted.length) {
	        return original.length ? original : highlighted;
	      }
	      if (original[0].offset !== highlighted[0].offset) {
	        return (original[0].offset < highlighted[0].offset) ? original : highlighted;
	      }
	
	      /*
	      To avoid starting the stream just before it should stop the order is
	      ensured that original always starts first and closes last:
	
	      if (event1 == 'start' && event2 == 'start')
	        return original;
	      if (event1 == 'start' && event2 == 'stop')
	        return highlighted;
	      if (event1 == 'stop' && event2 == 'start')
	        return original;
	      if (event1 == 'stop' && event2 == 'stop')
	        return highlighted;
	
	      ... which is collapsed to:
	      */
	      return highlighted[0].event === 'start' ? original : highlighted;
	    }
	
	    function open(node) {
	      function attr_str(a) {return ' ' + a.nodeName + '="' + escape(a.value).replace('"', '&quot;') + '"';}
	      result += '<' + tag(node) + ArrayProto.map.call(node.attributes, attr_str).join('') + '>';
	    }
	
	    function close(node) {
	      result += '</' + tag(node) + '>';
	    }
	
	    function render(event) {
	      (event.event === 'start' ? open : close)(event.node);
	    }
	
	    while (original.length || highlighted.length) {
	      var stream = selectStream();
	      result += escape(value.substring(processed, stream[0].offset));
	      processed = stream[0].offset;
	      if (stream === original) {
	        /*
	        On any opening or closing tag of the original markup we first close
	        the entire highlighted node stack, then render the original tag along
	        with all the following original tags at the same offset and then
	        reopen all the tags on the highlighted stack.
	        */
	        nodeStack.reverse().forEach(close);
	        do {
	          render(stream.splice(0, 1)[0]);
	          stream = selectStream();
	        } while (stream === original && stream.length && stream[0].offset === processed);
	        nodeStack.reverse().forEach(open);
	      } else {
	        if (stream[0].event === 'start') {
	          nodeStack.push(stream[0].node);
	        } else {
	          nodeStack.pop();
	        }
	        render(stream.splice(0, 1)[0]);
	      }
	    }
	    return result + escape(value.substr(processed));
	  }
	
	  /* Initialization */
	
	  function expand_mode(mode) {
	    if (mode.variants && !mode.cached_variants) {
	      mode.cached_variants = mode.variants.map(function(variant) {
	        return inherit(mode, {variants: null}, variant);
	      });
	    }
	    return mode.cached_variants || (mode.endsWithParent && [inherit(mode)]) || [mode];
	  }
	
	  function compileLanguage(language) {
	
	    function reStr(re) {
	        return (re && re.source) || re;
	    }
	
	    function langRe(value, global) {
	      return new RegExp(
	        reStr(value),
	        'm' + (language.case_insensitive ? 'i' : '') + (global ? 'g' : '')
	      );
	    }
	
	    function compileMode(mode, parent) {
	      if (mode.compiled)
	        return;
	      mode.compiled = true;
	
	      mode.keywords = mode.keywords || mode.beginKeywords;
	      if (mode.keywords) {
	        var compiled_keywords = {};
	
	        var flatten = function(className, str) {
	          if (language.case_insensitive) {
	            str = str.toLowerCase();
	          }
	          str.split(' ').forEach(function(kw) {
	            var pair = kw.split('|');
	            compiled_keywords[pair[0]] = [className, pair[1] ? Number(pair[1]) : 1];
	          });
	        };
	
	        if (typeof mode.keywords === 'string') { // string
	          flatten('keyword', mode.keywords);
	        } else {
	          objectKeys(mode.keywords).forEach(function (className) {
	            flatten(className, mode.keywords[className]);
	          });
	        }
	        mode.keywords = compiled_keywords;
	      }
	      mode.lexemesRe = langRe(mode.lexemes || /\w+/, true);
	
	      if (parent) {
	        if (mode.beginKeywords) {
	          mode.begin = '\\b(' + mode.beginKeywords.split(' ').join('|') + ')\\b';
	        }
	        if (!mode.begin)
	          mode.begin = /\B|\b/;
	        mode.beginRe = langRe(mode.begin);
	        if (!mode.end && !mode.endsWithParent)
	          mode.end = /\B|\b/;
	        if (mode.end)
	          mode.endRe = langRe(mode.end);
	        mode.terminator_end = reStr(mode.end) || '';
	        if (mode.endsWithParent && parent.terminator_end)
	          mode.terminator_end += (mode.end ? '|' : '') + parent.terminator_end;
	      }
	      if (mode.illegal)
	        mode.illegalRe = langRe(mode.illegal);
	      if (mode.relevance == null)
	        mode.relevance = 1;
	      if (!mode.contains) {
	        mode.contains = [];
	      }
	      mode.contains = Array.prototype.concat.apply([], mode.contains.map(function(c) {
	        return expand_mode(c === 'self' ? mode : c)
	      }));
	      mode.contains.forEach(function(c) {compileMode(c, mode);});
	
	      if (mode.starts) {
	        compileMode(mode.starts, parent);
	      }
	
	      var terminators =
	        mode.contains.map(function(c) {
	          return c.beginKeywords ? '\\.?(' + c.begin + ')\\.?' : c.begin;
	        })
	        .concat([mode.terminator_end, mode.illegal])
	        .map(reStr)
	        .filter(Boolean);
	      mode.terminators = terminators.length ? langRe(terminators.join('|'), true) : {exec: function(/*s*/) {return null;}};
	    }
	
	    compileMode(language);
	  }
	
	  /*
	  Core highlighting function. Accepts a language name, or an alias, and a
	  string with the code to highlight. Returns an object with the following
	  properties:
	
	  - relevance (int)
	  - value (an HTML string with highlighting markup)
	
	  */
	  function highlight(name, value, ignore_illegals, continuation) {
	
	    function subMode(lexeme, mode) {
	      var i, length;
	
	      for (i = 0, length = mode.contains.length; i < length; i++) {
	        if (testRe(mode.contains[i].beginRe, lexeme)) {
	          return mode.contains[i];
	        }
	      }
	    }
	
	    function endOfMode(mode, lexeme) {
	      if (testRe(mode.endRe, lexeme)) {
	        while (mode.endsParent && mode.parent) {
	          mode = mode.parent;
	        }
	        return mode;
	      }
	      if (mode.endsWithParent) {
	        return endOfMode(mode.parent, lexeme);
	      }
	    }
	
	    function isIllegal(lexeme, mode) {
	      return !ignore_illegals && testRe(mode.illegalRe, lexeme);
	    }
	
	    function keywordMatch(mode, match) {
	      var match_str = language.case_insensitive ? match[0].toLowerCase() : match[0];
	      return mode.keywords.hasOwnProperty(match_str) && mode.keywords[match_str];
	    }
	
	    function buildSpan(classname, insideSpan, leaveOpen, noPrefix) {
	      var classPrefix = noPrefix ? '' : options.classPrefix,
	          openSpan    = '<span class="' + classPrefix,
	          closeSpan   = leaveOpen ? '' : spanEndTag
	
	      openSpan += classname + '">';
	
	      return openSpan + insideSpan + closeSpan;
	    }
	
	    function processKeywords() {
	      var keyword_match, last_index, match, result;
	
	      if (!top.keywords)
	        return escape(mode_buffer);
	
	      result = '';
	      last_index = 0;
	      top.lexemesRe.lastIndex = 0;
	      match = top.lexemesRe.exec(mode_buffer);
	
	      while (match) {
	        result += escape(mode_buffer.substring(last_index, match.index));
	        keyword_match = keywordMatch(top, match);
	        if (keyword_match) {
	          relevance += keyword_match[1];
	          result += buildSpan(keyword_match[0], escape(match[0]));
	        } else {
	          result += escape(match[0]);
	        }
	        last_index = top.lexemesRe.lastIndex;
	        match = top.lexemesRe.exec(mode_buffer);
	      }
	      return result + escape(mode_buffer.substr(last_index));
	    }
	
	    function processSubLanguage() {
	      var explicit = typeof top.subLanguage === 'string';
	      if (explicit && !languages[top.subLanguage]) {
	        return escape(mode_buffer);
	      }
	
	      var result = explicit ?
	                   highlight(top.subLanguage, mode_buffer, true, continuations[top.subLanguage]) :
	                   highlightAuto(mode_buffer, top.subLanguage.length ? top.subLanguage : undefined);
	
	      // Counting embedded language score towards the host language may be disabled
	      // with zeroing the containing mode relevance. Usecase in point is Markdown that
	      // allows XML everywhere and makes every XML snippet to have a much larger Markdown
	      // score.
	      if (top.relevance > 0) {
	        relevance += result.relevance;
	      }
	      if (explicit) {
	        continuations[top.subLanguage] = result.top;
	      }
	      return buildSpan(result.language, result.value, false, true);
	    }
	
	    function processBuffer() {
	      result += (top.subLanguage != null ? processSubLanguage() : processKeywords());
	      mode_buffer = '';
	    }
	
	    function startNewMode(mode) {
	      result += mode.className? buildSpan(mode.className, '', true): '';
	      top = Object.create(mode, {parent: {value: top}});
	    }
	
	    function processLexeme(buffer, lexeme) {
	
	      mode_buffer += buffer;
	
	      if (lexeme == null) {
	        processBuffer();
	        return 0;
	      }
	
	      var new_mode = subMode(lexeme, top);
	      if (new_mode) {
	        if (new_mode.skip) {
	          mode_buffer += lexeme;
	        } else {
	          if (new_mode.excludeBegin) {
	            mode_buffer += lexeme;
	          }
	          processBuffer();
	          if (!new_mode.returnBegin && !new_mode.excludeBegin) {
	            mode_buffer = lexeme;
	          }
	        }
	        startNewMode(new_mode, lexeme);
	        return new_mode.returnBegin ? 0 : lexeme.length;
	      }
	
	      var end_mode = endOfMode(top, lexeme);
	      if (end_mode) {
	        var origin = top;
	        if (origin.skip) {
	          mode_buffer += lexeme;
	        } else {
	          if (!(origin.returnEnd || origin.excludeEnd)) {
	            mode_buffer += lexeme;
	          }
	          processBuffer();
	          if (origin.excludeEnd) {
	            mode_buffer = lexeme;
	          }
	        }
	        do {
	          if (top.className) {
	            result += spanEndTag;
	          }
	          if (!top.skip) {
	            relevance += top.relevance;
	          }
	          top = top.parent;
	        } while (top !== end_mode.parent);
	        if (end_mode.starts) {
	          startNewMode(end_mode.starts, '');
	        }
	        return origin.returnEnd ? 0 : lexeme.length;
	      }
	
	      if (isIllegal(lexeme, top))
	        throw new Error('Illegal lexeme "' + lexeme + '" for mode "' + (top.className || '<unnamed>') + '"');
	
	      /*
	      Parser should not reach this point as all types of lexemes should be caught
	      earlier, but if it does due to some bug make sure it advances at least one
	      character forward to prevent infinite looping.
	      */
	      mode_buffer += lexeme;
	      return lexeme.length || 1;
	    }
	
	    var language = getLanguage(name);
	    if (!language) {
	      throw new Error('Unknown language: "' + name + '"');
	    }
	
	    compileLanguage(language);
	    var top = continuation || language;
	    var continuations = {}; // keep continuations for sub-languages
	    var result = '', current;
	    for(current = top; current !== language; current = current.parent) {
	      if (current.className) {
	        result = buildSpan(current.className, '', true) + result;
	      }
	    }
	    var mode_buffer = '';
	    var relevance = 0;
	    try {
	      var match, count, index = 0;
	      while (true) {
	        top.terminators.lastIndex = index;
	        match = top.terminators.exec(value);
	        if (!match)
	          break;
	        count = processLexeme(value.substring(index, match.index), match[0]);
	        index = match.index + count;
	      }
	      processLexeme(value.substr(index));
	      for(current = top; current.parent; current = current.parent) { // close dangling modes
	        if (current.className) {
	          result += spanEndTag;
	        }
	      }
	      return {
	        relevance: relevance,
	        value: result,
	        language: name,
	        top: top
	      };
	    } catch (e) {
	      if (e.message && e.message.indexOf('Illegal') !== -1) {
	        return {
	          relevance: 0,
	          value: escape(value)
	        };
	      } else {
	        throw e;
	      }
	    }
	  }
	
	  /*
	  Highlighting with language detection. Accepts a string with the code to
	  highlight. Returns an object with the following properties:
	
	  - language (detected language)
	  - relevance (int)
	  - value (an HTML string with highlighting markup)
	  - second_best (object with the same structure for second-best heuristically
	    detected language, may be absent)
	
	  */
	  function highlightAuto(text, languageSubset) {
	    languageSubset = languageSubset || options.languages || objectKeys(languages);
	    var result = {
	      relevance: 0,
	      value: escape(text)
	    };
	    var second_best = result;
	    languageSubset.filter(getLanguage).forEach(function(name) {
	      var current = highlight(name, text, false);
	      current.language = name;
	      if (current.relevance > second_best.relevance) {
	        second_best = current;
	      }
	      if (current.relevance > result.relevance) {
	        second_best = result;
	        result = current;
	      }
	    });
	    if (second_best.language) {
	      result.second_best = second_best;
	    }
	    return result;
	  }
	
	  /*
	  Post-processing of the highlighted markup:
	
	  - replace TABs with something more useful
	  - replace real line-breaks with '<br>' for non-pre containers
	
	  */
	  function fixMarkup(value) {
	    return !(options.tabReplace || options.useBR)
	      ? value
	      : value.replace(fixMarkupRe, function(match, p1) {
	          if (options.useBR && match === '\n') {
	            return '<br>';
	          } else if (options.tabReplace) {
	            return p1.replace(/\t/g, options.tabReplace);
	          }
	          return '';
	      });
	  }
	
	  function buildClassName(prevClassName, currentLang, resultLang) {
	    var language = currentLang ? aliases[currentLang] : resultLang,
	        result   = [prevClassName.trim()];
	
	    if (!prevClassName.match(/\bhljs\b/)) {
	      result.push('hljs');
	    }
	
	    if (prevClassName.indexOf(language) === -1) {
	      result.push(language);
	    }
	
	    return result.join(' ').trim();
	  }
	
	  /*
	  Applies highlighting to a DOM node containing code. Accepts a DOM node and
	  two optional parameters for fixMarkup.
	  */
	  function highlightBlock(block) {
	    var node, originalStream, result, resultNode, text;
	    var language = blockLanguage(block);
	
	    if (isNotHighlighted(language))
	        return;
	
	    if (options.useBR) {
	      node = document.createElementNS('http://www.w3.org/1999/xhtml', 'div');
	      node.innerHTML = block.innerHTML.replace(/\n/g, '').replace(/<br[ \/]*>/g, '\n');
	    } else {
	      node = block;
	    }
	    text = node.textContent;
	    result = language ? highlight(language, text, true) : highlightAuto(text);
	
	    originalStream = nodeStream(node);
	    if (originalStream.length) {
	      resultNode = document.createElementNS('http://www.w3.org/1999/xhtml', 'div');
	      resultNode.innerHTML = result.value;
	      result.value = mergeStreams(originalStream, nodeStream(resultNode), text);
	    }
	    result.value = fixMarkup(result.value);
	
	    block.innerHTML = result.value;
	    block.className = buildClassName(block.className, language, result.language);
	    block.result = {
	      language: result.language,
	      re: result.relevance
	    };
	    if (result.second_best) {
	      block.second_best = {
	        language: result.second_best.language,
	        re: result.second_best.relevance
	      };
	    }
	  }
	
	  /*
	  Updates highlight.js global options with values passed in the form of an object.
	  */
	  function configure(user_options) {
	    options = inherit(options, user_options);
	  }
	
	  /*
	  Applies highlighting to all <pre><code>..</code></pre> blocks on a page.
	  */
	  function initHighlighting() {
	    if (initHighlighting.called)
	      return;
	    initHighlighting.called = true;
	
	    var blocks = document.querySelectorAll('pre code');
	    ArrayProto.forEach.call(blocks, highlightBlock);
	  }
	
	  /*
	  Attaches highlighting to the page load event.
	  */
	  function initHighlightingOnLoad() {
	    addEventListener('DOMContentLoaded', initHighlighting, false);
	    addEventListener('load', initHighlighting, false);
	  }
	
	  function registerLanguage(name, language) {
	    var lang = languages[name] = language(hljs);
	    if (lang.aliases) {
	      lang.aliases.forEach(function(alias) {aliases[alias] = name;});
	    }
	  }
	
	  function listLanguages() {
	    return objectKeys(languages);
	  }
	
	  function getLanguage(name) {
	    name = (name || '').toLowerCase();
	    return languages[name] || languages[aliases[name]];
	  }
	
	  /* Interface definition */
	
	  hljs.highlight = highlight;
	  hljs.highlightAuto = highlightAuto;
	  hljs.fixMarkup = fixMarkup;
	  hljs.highlightBlock = highlightBlock;
	  hljs.configure = configure;
	  hljs.initHighlighting = initHighlighting;
	  hljs.initHighlightingOnLoad = initHighlightingOnLoad;
	  hljs.registerLanguage = registerLanguage;
	  hljs.listLanguages = listLanguages;
	  hljs.getLanguage = getLanguage;
	  hljs.inherit = inherit;
	
	  // Common regexps
	  hljs.IDENT_RE = '[a-zA-Z]\\w*';
	  hljs.UNDERSCORE_IDENT_RE = '[a-zA-Z_]\\w*';
	  hljs.NUMBER_RE = '\\b\\d+(\\.\\d+)?';
	  hljs.C_NUMBER_RE = '(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)'; // 0x..., 0..., decimal, float
	  hljs.BINARY_NUMBER_RE = '\\b(0b[01]+)'; // 0b...
	  hljs.RE_STARTERS_RE = '!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~';
	
	  // Common modes
	  hljs.BACKSLASH_ESCAPE = {
	    begin: '\\\\[\\s\\S]', relevance: 0
	  };
	  hljs.APOS_STRING_MODE = {
	    className: 'string',
	    begin: '\'', end: '\'',
	    illegal: '\\n',
	    contains: [hljs.BACKSLASH_ESCAPE]
	  };
	  hljs.QUOTE_STRING_MODE = {
	    className: 'string',
	    begin: '"', end: '"',
	    illegal: '\\n',
	    contains: [hljs.BACKSLASH_ESCAPE]
	  };
	  hljs.PHRASAL_WORDS_MODE = {
	    begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
	  };
	  hljs.COMMENT = function (begin, end, inherits) {
	    var mode = hljs.inherit(
	      {
	        className: 'comment',
	        begin: begin, end: end,
	        contains: []
	      },
	      inherits || {}
	    );
	    mode.contains.push(hljs.PHRASAL_WORDS_MODE);
	    mode.contains.push({
	      className: 'doctag',
	      begin: '(?:TODO|FIXME|NOTE|BUG|XXX):',
	      relevance: 0
	    });
	    return mode;
	  };
	  hljs.C_LINE_COMMENT_MODE = hljs.COMMENT('//', '$');
	  hljs.C_BLOCK_COMMENT_MODE = hljs.COMMENT('/\\*', '\\*/');
	  hljs.HASH_COMMENT_MODE = hljs.COMMENT('#', '$');
	  hljs.NUMBER_MODE = {
	    className: 'number',
	    begin: hljs.NUMBER_RE,
	    relevance: 0
	  };
	  hljs.C_NUMBER_MODE = {
	    className: 'number',
	    begin: hljs.C_NUMBER_RE,
	    relevance: 0
	  };
	  hljs.BINARY_NUMBER_MODE = {
	    className: 'number',
	    begin: hljs.BINARY_NUMBER_RE,
	    relevance: 0
	  };
	  hljs.CSS_NUMBER_MODE = {
	    className: 'number',
	    begin: hljs.NUMBER_RE + '(' +
	      '%|em|ex|ch|rem'  +
	      '|vw|vh|vmin|vmax' +
	      '|cm|mm|in|pt|pc|px' +
	      '|deg|grad|rad|turn' +
	      '|s|ms' +
	      '|Hz|kHz' +
	      '|dpi|dpcm|dppx' +
	      ')?',
	    relevance: 0
	  };
	  hljs.REGEXP_MODE = {
	    className: 'regexp',
	    begin: /\//, end: /\/[gimuy]*/,
	    illegal: /\n/,
	    contains: [
	      hljs.BACKSLASH_ESCAPE,
	      {
	        begin: /\[/, end: /\]/,
	        relevance: 0,
	        contains: [hljs.BACKSLASH_ESCAPE]
	      }
	    ]
	  };
	  hljs.TITLE_MODE = {
	    className: 'title',
	    begin: hljs.IDENT_RE,
	    relevance: 0
	  };
	  hljs.UNDERSCORE_TITLE_MODE = {
	    className: 'title',
	    begin: hljs.UNDERSCORE_IDENT_RE,
	    relevance: 0
	  };
	  hljs.METHOD_GUARD = {
	    // excludes method names from keyword processing
	    begin: '\\.\\s*' + hljs.UNDERSCORE_IDENT_RE,
	    relevance: 0
	  };
	
	  return hljs;
	}));


/***/ }),

/***/ 317:
/***/ (function(module, exports) {

	module.exports = function(hljs) {
	  var IDENT_RE = '[A-Za-z$_][0-9A-Za-z$_]*';
	  var KEYWORDS = {
	    keyword:
	      'in of if for while finally var new function do return void else break catch ' +
	      'instanceof with throw case default try this switch continue typeof delete ' +
	      'let yield const export super debugger as async await static ' +
	      // ECMAScript 6 modules import
	      'import from as'
	    ,
	    literal:
	      'true false null undefined NaN Infinity',
	    built_in:
	      'eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent ' +
	      'encodeURI encodeURIComponent escape unescape Object Function Boolean Error ' +
	      'EvalError InternalError RangeError ReferenceError StopIteration SyntaxError ' +
	      'TypeError URIError Number Math Date String RegExp Array Float32Array ' +
	      'Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array ' +
	      'Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require ' +
	      'module console window document Symbol Set Map WeakSet WeakMap Proxy Reflect ' +
	      'Promise'
	  };
	  var EXPRESSIONS;
	  var NUMBER = {
	    className: 'number',
	    variants: [
	      { begin: '\\b(0[bB][01]+)' },
	      { begin: '\\b(0[oO][0-7]+)' },
	      { begin: hljs.C_NUMBER_RE }
	    ],
	    relevance: 0
	  };
	  var SUBST = {
	    className: 'subst',
	    begin: '\\$\\{', end: '\\}',
	    keywords: KEYWORDS,
	    contains: []  // defined later
	  };
	  var TEMPLATE_STRING = {
	    className: 'string',
	    begin: '`', end: '`',
	    contains: [
	      hljs.BACKSLASH_ESCAPE,
	      SUBST
	    ]
	  };
	  SUBST.contains = [
	    hljs.APOS_STRING_MODE,
	    hljs.QUOTE_STRING_MODE,
	    TEMPLATE_STRING,
	    NUMBER,
	    hljs.REGEXP_MODE
	  ]
	  var PARAMS_CONTAINS = SUBST.contains.concat([
	    hljs.C_BLOCK_COMMENT_MODE,
	    hljs.C_LINE_COMMENT_MODE
	  ]);
	
	  return {
	    aliases: ['js', 'jsx'],
	    keywords: KEYWORDS,
	    contains: [
	      {
	        className: 'meta',
	        relevance: 10,
	        begin: /^\s*['"]use (strict|asm)['"]/
	      },
	      {
	        className: 'meta',
	        begin: /^#!/, end: /$/
	      },
	      hljs.APOS_STRING_MODE,
	      hljs.QUOTE_STRING_MODE,
	      TEMPLATE_STRING,
	      hljs.C_LINE_COMMENT_MODE,
	      hljs.C_BLOCK_COMMENT_MODE,
	      NUMBER,
	      { // object attr container
	        begin: /[{,]\s*/, relevance: 0,
	        contains: [
	          {
	            begin: IDENT_RE + '\\s*:', returnBegin: true,
	            relevance: 0,
	            contains: [{className: 'attr', begin: IDENT_RE, relevance: 0}]
	          }
	        ]
	      },
	      { // "value" container
	        begin: '(' + hljs.RE_STARTERS_RE + '|\\b(case|return|throw)\\b)\\s*',
	        keywords: 'return throw case',
	        contains: [
	          hljs.C_LINE_COMMENT_MODE,
	          hljs.C_BLOCK_COMMENT_MODE,
	          hljs.REGEXP_MODE,
	          {
	            className: 'function',
	            begin: '(\\(.*?\\)|' + IDENT_RE + ')\\s*=>', returnBegin: true,
	            end: '\\s*=>',
	            contains: [
	              {
	                className: 'params',
	                variants: [
	                  {
	                    begin: IDENT_RE
	                  },
	                  {
	                    begin: /\(\s*\)/,
	                  },
	                  {
	                    begin: /\(/, end: /\)/,
	                    excludeBegin: true, excludeEnd: true,
	                    keywords: KEYWORDS,
	                    contains: PARAMS_CONTAINS
	                  }
	                ]
	              }
	            ]
	          },
	          { // E4X / JSX
	            begin: /</, end: /(\/\w+|\w+\/)>/,
	            subLanguage: 'xml',
	            contains: [
	              {begin: /<\w+\s*\/>/, skip: true},
	              {
	                begin: /<\w+/, end: /(\/\w+|\w+\/)>/, skip: true,
	                contains: [
	                  {begin: /<\w+\s*\/>/, skip: true},
	                  'self'
	                ]
	              }
	            ]
	          }
	        ],
	        relevance: 0
	      },
	      {
	        className: 'function',
	        beginKeywords: 'function', end: /\{/, excludeEnd: true,
	        contains: [
	          hljs.inherit(hljs.TITLE_MODE, {begin: IDENT_RE}),
	          {
	            className: 'params',
	            begin: /\(/, end: /\)/,
	            excludeBegin: true,
	            excludeEnd: true,
	            contains: PARAMS_CONTAINS
	          }
	        ],
	        illegal: /\[|%/
	      },
	      {
	        begin: /\$[(.]/ // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
	      },
	      hljs.METHOD_GUARD,
	      { // ES6 class
	        className: 'class',
	        beginKeywords: 'class', end: /[{;=]/, excludeEnd: true,
	        illegal: /[:"\[\]]/,
	        contains: [
	          {beginKeywords: 'extends'},
	          hljs.UNDERSCORE_TITLE_MODE
	        ]
	      },
	      {
	        beginKeywords: 'constructor', end: /\{/, excludeEnd: true
	      }
	    ],
	    illegal: /#(?!!)/
	  };
	};

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 324:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

	'use strict'
	
	var high = __webpack_require__(316)
	var fault = __webpack_require__(291)
	
	/* The lowlight interface, which has to be compatible
	 * with highlight.js, as this object is passed to
	 * highlight.js syntaxes. */
	
	function High() {}
	
	High.prototype = high
	
	/* Expose. */
	var low = new High() // Ha!
	
	module.exports = low
	
	low.highlight = highlight
	low.highlightAuto = autoHighlight
	low.registerLanguage = registerLanguage
	low.getLanguage = getLanguage
	
	var inherit = high.inherit
	var own = {}.hasOwnProperty
	var concat = [].concat
	
	var defaultPrefix = 'hljs-'
	var keyInsensitive = 'case_insensitive'
	var keyCachedVariants = 'cached_variants'
	var space = ' '
	var pipe = '|'
	
	var T_ELEMENT = 'element'
	var T_TEXT = 'text'
	var T_SPAN = 'span'
	
	/* Maps of syntaxes. */
	var languageNames = []
	var languages = {}
	var aliases = {}
	
	/* Highlighting with language detection.  Accepts a string
	 * with the code to highlight.  Returns an object with the
	 * following properties:
	 *
	 * - language (detected language)
	 * - relevance (int)
	 * - value (a HAST tree with highlighting markup)
	 * - secondBest (object with the same structure for
	 *   second-best heuristically detected language, may
	 *   be absent) */
	function autoHighlight(value, options) {
	  var settings = options || {}
	  var subset = settings.subset || languageNames
	  var prefix = settings.prefix
	  var length = subset.length
	  var index = -1
	  var result
	  var secondBest
	  var current
	  var name
	
	  if (prefix === null || prefix === undefined) {
	    prefix = defaultPrefix
	  }
	
	  if (typeof value !== 'string') {
	    throw fault('Expected `string` for value, got `%s`', value)
	  }
	
	  secondBest = normalize({})
	  result = normalize({})
	
	  while (++index < length) {
	    name = subset[index]
	
	    if (!getLanguage(name)) {
	      continue
	    }
	
	    current = normalize(coreHighlight(name, value, false, prefix))
	
	    current.language = name
	
	    if (current.relevance > secondBest.relevance) {
	      secondBest = current
	    }
	
	    if (current.relevance > result.relevance) {
	      secondBest = result
	      result = current
	    }
	  }
	
	  if (secondBest.language) {
	    result.secondBest = secondBest
	  }
	
	  return result
	}
	
	/* Highlighting `value` in the language `language`. */
	function highlight(language, value, options) {
	  var settings = options || {}
	  var prefix = settings.prefix
	
	  if (prefix === null || prefix === undefined) {
	    prefix = defaultPrefix
	  }
	
	  return normalize(coreHighlight(language, value, true, prefix))
	}
	
	/* Register a language. */
	function registerLanguage(name, syntax) {
	  var lang = syntax(low)
	  var values = lang.aliases
	  var length = values && values.length
	  var index = -1
	
	  languages[name] = lang
	
	  languageNames.push(name)
	
	  while (++index < length) {
	    aliases[values[index]] = name
	  }
	}
	
	/* Core highlighting function.  Accepts a language name, or
	 * an alias, and a string with the code to highlight.
	 * Returns an object with the following properties: */
	function coreHighlight(name, value, ignore, prefix, continuation) {
	  var continuations = {}
	  var stack = []
	  var modeBuffer = ''
	  var relevance = 0
	  var language
	  var top
	  var current
	  var currentChildren
	  var offset
	  var count
	  var match
	  var children
	
	  if (typeof name !== 'string') {
	    throw fault('Expected `string` for name, got `%s`', name)
	  }
	
	  if (typeof value !== 'string') {
	    throw fault('Expected `string` for value, got `%s`', value)
	  }
	
	  language = getLanguage(name)
	  top = continuation || language
	  children = []
	
	  current = top
	  currentChildren = children
	
	  if (!language) {
	    throw fault('Unknown language: `%s` is not registered', name)
	  }
	
	  compileLanguage(language)
	
	  try {
	    top.terminators.lastIndex = 0
	    offset = 0
	    match = top.terminators.exec(value)
	
	    while (match) {
	      count = processLexeme(value.substring(offset, match.index), match[0])
	      offset = match.index + count
	      top.terminators.lastIndex = offset
	      match = top.terminators.exec(value)
	    }
	
	    processLexeme(value.substr(offset))
	    current = top
	
	    while (current.parent) {
	      if (current.className) {
	        pop()
	      }
	
	      current = current.parent
	    }
	
	    return {
	      relevance: relevance,
	      value: currentChildren,
	      language: name,
	      top: top
	    }
	  } catch (err) {
	    /* istanbul ignore if - Catch-all  */
	    if (err.message.indexOf('Illegal') === -1) {
	      throw err
	    }
	
	    return {relevance: 0, value: addText(value, [])}
	  }
	
	  /* Process a lexeme.  Returns next position. */
	  function processLexeme(buffer, lexeme) {
	    var newMode
	    var endMode
	    var origin
	
	    modeBuffer += buffer
	
	    if (lexeme === undefined) {
	      addSiblings(processBuffer(), currentChildren)
	
	      return 0
	    }
	
	    newMode = subMode(lexeme, top)
	
	    if (newMode) {
	      addSiblings(processBuffer(), currentChildren)
	
	      startNewMode(newMode, lexeme)
	
	      return newMode.returnBegin ? 0 : lexeme.length
	    }
	
	    endMode = endOfMode(top, lexeme)
	
	    if (endMode) {
	      origin = top
	
	      if (!(origin.returnEnd || origin.excludeEnd)) {
	        modeBuffer += lexeme
	      }
	
	      addSiblings(processBuffer(), currentChildren)
	
	      /* Close open modes. */
	      do {
	        if (top.className) {
	          pop()
	        }
	
	        relevance += top.relevance
	        top = top.parent
	      } while (top !== endMode.parent)
	
	      if (origin.excludeEnd) {
	        addText(lexeme, currentChildren)
	      }
	
	      modeBuffer = ''
	
	      if (endMode.starts) {
	        startNewMode(endMode.starts, '')
	      }
	
	      return origin.returnEnd ? 0 : lexeme.length
	    }
	
	    if (isIllegal(lexeme, top)) {
	      throw fault(
	        'Illegal lexeme "%s" for mode "%s"',
	        lexeme,
	        top.className || '<unnamed>'
	      )
	    }
	
	    /* Parser should not reach this point as all
	     * types of lexemes should be caught earlier,
	     * but if it does due to some bug make sure it
	     * advances at least one character forward to
	     * prevent infinite looping. */
	    modeBuffer += lexeme
	
	    return lexeme.length || /* istanbul ignore next */ 1
	  }
	
	  /* Start a new mode with a `lexeme` to process. */
	  function startNewMode(mode, lexeme) {
	    var node
	
	    if (mode.className) {
	      node = build(mode.className, [])
	    }
	
	    if (mode.returnBegin) {
	      modeBuffer = ''
	    } else if (mode.excludeBegin) {
	      addText(lexeme, currentChildren)
	
	      modeBuffer = ''
	    } else {
	      modeBuffer = lexeme
	    }
	
	    /* Enter a new mode. */
	    if (node) {
	      currentChildren.push(node)
	      stack.push(currentChildren)
	      currentChildren = node.children
	    }
	
	    top = Object.create(mode, {parent: {value: top}})
	  }
	
	  /* Process the buffer. */
	  function processBuffer() {
	    var result = top.subLanguage ? processSubLanguage() : processKeywords()
	    modeBuffer = ''
	    return result
	  }
	
	  /* Process a sublanguage (returns a list of nodes). */
	  function processSubLanguage() {
	    var explicit = typeof top.subLanguage === 'string'
	    var subvalue
	
	    /* istanbul ignore if - support non-loaded sublanguages */
	    if (explicit && !languages[top.subLanguage]) {
	      return addText(modeBuffer, [])
	    }
	
	    if (explicit) {
	      subvalue = coreHighlight(
	        top.subLanguage,
	        modeBuffer,
	        true,
	        prefix,
	        continuations[top.subLanguage]
	      )
	    } else {
	      subvalue = autoHighlight(modeBuffer, {
	        subset: top.subLanguage.length ? top.subLanguage : undefined,
	        prefix: prefix
	      })
	    }
	
	    /* Counting embedded language score towards the
	     * host language may be disabled with zeroing the
	     * containing mode relevance.  Usecase in point is
	     * Markdown that allows XML everywhere and makes
	     * every XML snippet to have a much larger Markdown
	     * score. */
	    if (top.relevance > 0) {
	      relevance += subvalue.relevance
	    }
	
	    if (explicit) {
	      continuations[top.subLanguage] = subvalue.top
	    }
	
	    return [build(subvalue.language, subvalue.value, true)]
	  }
	
	  /* Process keywords. Returns nodes. */
	  function processKeywords() {
	    var nodes = []
	    var lastIndex
	    var keyword
	    var node
	    var submatch
	
	    if (!top.keywords) {
	      return addText(modeBuffer, nodes)
	    }
	
	    lastIndex = 0
	
	    top.lexemesRe.lastIndex = 0
	
	    keyword = top.lexemesRe.exec(modeBuffer)
	
	    while (keyword) {
	      addText(modeBuffer.substring(lastIndex, keyword.index), nodes)
	
	      submatch = keywordMatch(top, keyword)
	
	      if (submatch) {
	        relevance += submatch[1]
	
	        node = build(submatch[0], [])
	
	        nodes.push(node)
	
	        addText(keyword[0], node.children)
	      } else {
	        addText(keyword[0], nodes)
	      }
	
	      lastIndex = top.lexemesRe.lastIndex
	      keyword = top.lexemesRe.exec(modeBuffer)
	    }
	
	    addText(modeBuffer.substr(lastIndex), nodes)
	
	    return nodes
	  }
	
	  /* Add siblings. */
	  function addSiblings(siblings, nodes) {
	    var length = siblings.length
	    var index = -1
	    var sibling
	
	    while (++index < length) {
	      sibling = siblings[index]
	
	      if (sibling.type === T_TEXT) {
	        addText(sibling.value, nodes)
	      } else {
	        nodes.push(sibling)
	      }
	    }
	  }
	
	  /* Add a text. */
	  function addText(value, nodes) {
	    var tail
	
	    if (value) {
	      tail = nodes[nodes.length - 1]
	
	      if (tail && tail.type === T_TEXT) {
	        tail.value += value
	      } else {
	        nodes.push(buildText(value))
	      }
	    }
	
	    return nodes
	  }
	
	  /* Build a text. */
	  function buildText(value) {
	    return {type: T_TEXT, value: value}
	  }
	
	  /* Build a span. */
	  function build(name, contents, noPrefix) {
	    return {
	      type: T_ELEMENT,
	      tagName: T_SPAN,
	      properties: {
	        className: [(noPrefix ? '' : prefix) + name]
	      },
	      children: contents
	    }
	  }
	
	  /* Check if the first word in `keywords` is a keyword. */
	  function keywordMatch(mode, keywords) {
	    var keyword = keywords[0]
	
	    if (language[keyInsensitive]) {
	      keyword = keyword.toLowerCase()
	    }
	
	    return own.call(mode.keywords, keyword) && mode.keywords[keyword]
	  }
	
	  /* Check if `lexeme` is illegal according to `mode`. */
	  function isIllegal(lexeme, mode) {
	    return !ignore && test(mode.illegalRe, lexeme)
	  }
	
	  /* Check if `lexeme` ends `mode`. */
	  function endOfMode(mode, lexeme) {
	    if (test(mode.endRe, lexeme)) {
	      while (mode.endsParent && mode.parent) {
	        mode = mode.parent
	      }
	
	      return mode
	    }
	
	    if (mode.endsWithParent) {
	      return endOfMode(mode.parent, lexeme)
	    }
	  }
	
	  /* Check a sub-mode. */
	  function subMode(lexeme, mode) {
	    var values = mode.contains
	    var length = values.length
	    var index = -1
	
	    while (++index < length) {
	      if (test(values[index].beginRe, lexeme)) {
	        return values[index]
	      }
	    }
	  }
	
	  /* Exit the current context. */
	  function pop() {
	    /* istanbul ignore next - removed in hljs 9.3 */
	    currentChildren = stack.pop() || children
	  }
	}
	
	function expandMode(mode) {
	  var length
	  var index
	  var variants
	  var result
	
	  if (mode.variants && !mode[keyCachedVariants]) {
	    variants = mode.variants
	    length = variants.length
	    index = -1
	    result = []
	
	    while (++index < length) {
	      result[index] = inherit(mode, {variants: null}, variants[index])
	    }
	
	    mode[keyCachedVariants] = result
	  }
	
	  return (
	    mode[keyCachedVariants] || (mode.endsWithParent ? [inherit(mode)] : [mode])
	  )
	}
	
	/* Compile a language. */
	function compileLanguage(language) {
	  compileMode(language)
	
	  /* Compile a language mode, optionally with a parent. */
	  function compileMode(mode, parent) {
	    var compiledKeywords = {}
	    var terminators
	
	    if (mode.compiled) {
	      return
	    }
	
	    mode.compiled = true
	
	    mode.keywords = mode.keywords || mode.beginKeywords
	
	    if (mode.keywords) {
	      if (typeof mode.keywords === 'string') {
	        flatten('keyword', mode.keywords)
	      } else {
	        Object.keys(mode.keywords).forEach(function(className) {
	          flatten(className, mode.keywords[className])
	        })
	      }
	
	      mode.keywords = compiledKeywords
	    }
	
	    mode.lexemesRe = langRe(mode.lexemes || /\w+/, true)
	
	    if (parent) {
	      if (mode.beginKeywords) {
	        mode.begin =
	          '\\b(' + mode.beginKeywords.split(space).join(pipe) + ')\\b'
	      }
	
	      if (!mode.begin) {
	        mode.begin = /\B|\b/
	      }
	
	      mode.beginRe = langRe(mode.begin)
	
	      if (!mode.end && !mode.endsWithParent) {
	        mode.end = /\B|\b/
	      }
	
	      if (mode.end) {
	        mode.endRe = langRe(mode.end)
	      }
	
	      mode.terminatorEnd = source(mode.end) || ''
	
	      if (mode.endsWithParent && parent.terminatorEnd) {
	        mode.terminatorEnd += (mode.end ? pipe : '') + parent.terminatorEnd
	      }
	    }
	
	    if (mode.illegal) {
	      mode.illegalRe = langRe(mode.illegal)
	    }
	
	    if (mode.relevance === undefined) {
	      mode.relevance = 1
	    }
	
	    if (!mode.contains) {
	      mode.contains = []
	    }
	
	    mode.contains = concat.apply(
	      [],
	      mode.contains.map(function(c) {
	        return expandMode(c === 'self' ? mode : c)
	      })
	    )
	
	    mode.contains.forEach(function(c) {
	      compileMode(c, mode)
	    })
	
	    if (mode.starts) {
	      compileMode(mode.starts, parent)
	    }
	
	    terminators = mode.contains
	      .map(map)
	      .concat([mode.terminatorEnd, mode.illegal])
	      .map(source)
	      .filter(Boolean)
	
	    mode.terminators = terminators.length
	      ? langRe(terminators.join(pipe), true)
	      : {exec: execNoop}
	
	    function map(c) {
	      return c.beginKeywords ? '\\.?(' + c.begin + ')\\.?' : c.begin
	    }
	
	    /* Flatten a classname. */
	    function flatten(className, value) {
	      var pairs
	      var pair
	      var index
	      var length
	
	      if (language[keyInsensitive]) {
	        value = value.toLowerCase()
	      }
	
	      pairs = value.split(space)
	      length = pairs.length
	      index = -1
	
	      while (++index < length) {
	        pair = pairs[index].split(pipe)
	
	        compiledKeywords[pair[0]] = [className, pair[1] ? Number(pair[1]) : 1]
	      }
	    }
	  }
	
	  /* Create a regex for `value`. */
	  function langRe(value, global) {
	    return new RegExp(
	      source(value),
	      'm' + (language[keyInsensitive] ? 'i' : '') + (global ? 'g' : '')
	    )
	  }
	
	  /* Get the source of an expression or string. */
	  function source(re) {
	    return (re && re.source) || re
	  }
	}
	
	/* Normalize a syntax result. */
	function normalize(result) {
	  return {
	    relevance: result.relevance || 0,
	    language: result.language || null,
	    value: result.value || []
	  }
	}
	
	/* Check if `expression` matches `lexeme`. */
	function test(expression, lexeme) {
	  var match = expression && expression.exec(lexeme)
	  return match && match.index === 0
	}
	
	/* No-op exec. */
	function execNoop() {
	  return null
	}
	
	/* Get a language by `name`. */
	function getLanguage(name) {
	  name = name.toLowerCase()
	
	  return languages[name] || languages[aliases[name]]
	}


/***/ }),

/***/ 4:
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(71);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(127);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.createStyleObject = createStyleObject;
	exports.createClassNameString = createClassNameString;
	exports.createChildren = createChildren;
	exports.default = createElement;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createStyleObject(classNames) {
	  var elementStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var stylesheet = arguments[2];
	
	  return classNames.reduce(function (styleObject, className) {
	    return (0, _extends3.default)({}, styleObject, stylesheet[className]);
	  }, elementStyle);
	}
	
	function createClassNameString(classNames) {
	  return classNames.join(' ');
	}
	
	function createChildren(stylesheet, useInlineStyles) {
	  var childrenCount = 0;
	  return function (children) {
	    childrenCount += 1;
	    return children.map(function (child, i) {
	      return createElement({
	        node: child,
	        stylesheet: stylesheet,
	        useInlineStyles: useInlineStyles,
	        key: 'code-segment-' + childrenCount + '-' + i
	      });
	    });
	  };
	}
	
	function createElement(_ref) {
	  var node = _ref.node,
	      stylesheet = _ref.stylesheet,
	      _ref$style = _ref.style,
	      style = _ref$style === undefined ? {} : _ref$style,
	      useInlineStyles = _ref.useInlineStyles,
	      key = _ref.key;
	  var properties = node.properties,
	      type = node.type,
	      TagName = node.tagName,
	      value = node.value;
	
	  if (type === 'text') {
	    return value;
	  } else if (TagName) {
	    var childrenCreator = createChildren(stylesheet, useInlineStyles);
	    var props = useInlineStyles ? (0, _extends3.default)({}, properties, { className: undefined }, {
	      style: createStyleObject(properties.className, (0, _assign2.default)({}, properties.style, style), stylesheet)
	    }) : (0, _extends3.default)({}, properties, { className: createClassNameString(properties.className) });
	    var children = childrenCreator(node.children);
	    return _react2.default.createElement(
	      TagName,
	      (0, _extends3.default)({ key: key }, props),
	      children
	    );
	  }
	}

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(128);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _assign = __webpack_require__(71);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.default = function (astGenerator, defaultStyle) {
	  return function SyntaxHighlighter(_ref6) {
	    var language = _ref6.language,
	        children = _ref6.children,
	        _ref6$style = _ref6.style,
	        style = _ref6$style === undefined ? defaultStyle : _ref6$style,
	        _ref6$customStyle = _ref6.customStyle,
	        customStyle = _ref6$customStyle === undefined ? {} : _ref6$customStyle,
	        _ref6$codeTagProps = _ref6.codeTagProps,
	        codeTagProps = _ref6$codeTagProps === undefined ? { style: style['code[class*=\"language-\"]'] } : _ref6$codeTagProps,
	        _ref6$useInlineStyles = _ref6.useInlineStyles,
	        useInlineStyles = _ref6$useInlineStyles === undefined ? true : _ref6$useInlineStyles,
	        _ref6$showLineNumbers = _ref6.showLineNumbers,
	        showLineNumbers = _ref6$showLineNumbers === undefined ? false : _ref6$showLineNumbers,
	        _ref6$startingLineNum = _ref6.startingLineNumber,
	        startingLineNumber = _ref6$startingLineNum === undefined ? 1 : _ref6$startingLineNum,
	        lineNumberContainerStyle = _ref6.lineNumberContainerStyle,
	        lineNumberStyle = _ref6.lineNumberStyle,
	        wrapLines = _ref6.wrapLines,
	        _ref6$lineProps = _ref6.lineProps,
	        lineProps = _ref6$lineProps === undefined ? {} : _ref6$lineProps,
	        renderer = _ref6.renderer,
	        _ref6$PreTag = _ref6.PreTag,
	        PreTag = _ref6$PreTag === undefined ? 'pre' : _ref6$PreTag,
	        _ref6$CodeTag = _ref6.CodeTag,
	        CodeTag = _ref6$CodeTag === undefined ? 'code' : _ref6$CodeTag,
	        _ref6$code = _ref6.code,
	        code = _ref6$code === undefined ? Array.isArray(children) ? children[0] : children : _ref6$code,
	        rest = (0, _objectWithoutProperties3.default)(_ref6, ['language', 'children', 'style', 'customStyle', 'codeTagProps', 'useInlineStyles', 'showLineNumbers', 'startingLineNumber', 'lineNumberContainerStyle', 'lineNumberStyle', 'wrapLines', 'lineProps', 'renderer', 'PreTag', 'CodeTag', 'code']);
	
	    /* 
	     * some custom renderers rely on individual row elements so we need to turn wrapLines on 
	     * if renderer is provided and wrapLines is undefined
	    */
	    wrapLines = renderer && wrapLines === undefined ? true : wrapLines;
	    renderer = renderer || defaultRenderer;
	    var defaultCodeValue = [{ type: 'text', value: code }];
	    var codeTree = getCodeTree({ astGenerator: astGenerator, language: language, code: code, defaultCodeValue: defaultCodeValue });
	    if (codeTree.language === null) {
	      codeTree.value = defaultCodeValue;
	    }
	    var defaultPreStyle = style.hljs || style['pre[class*=\"language-\"]'] || { backgroundColor: '#fff' };
	    var preProps = useInlineStyles ? (0, _assign2.default)({}, rest, { style: (0, _assign2.default)({}, defaultPreStyle, customStyle) }) : (0, _assign2.default)({}, rest, { className: 'hljs' });
	    var tree = wrapLines ? wrapLinesInSpan(codeTree, lineProps) : codeTree.value;
	    var lineNumbers = showLineNumbers ? _react2.default.createElement(LineNumbers, {
	      containerStyle: lineNumberContainerStyle,
	      codeStyle: codeTagProps.style || {},
	      numberStyle: lineNumberStyle,
	      startingLineNumber: startingLineNumber,
	      codeString: code
	    }) : null;
	    return _react2.default.createElement(
	      PreTag,
	      preProps,
	      lineNumbers,
	      _react2.default.createElement(
	        CodeTag,
	        codeTagProps,
	        renderer({ rows: tree, stylesheet: style, useInlineStyles: useInlineStyles })
	      )
	    );
	  };
	};
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createElement = __webpack_require__(413);
	
	var _createElement2 = _interopRequireDefault(_createElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var newLineRegex = /\n/g;
	function getNewLines(str) {
	  return str.match(newLineRegex);
	}
	
	function getLineNumbers(_ref) {
	  var lines = _ref.lines,
	      startingLineNumber = _ref.startingLineNumber,
	      style = _ref.style;
	
	  return lines.map(function (_, i) {
	    var number = i + startingLineNumber;
	    return _react2.default.createElement(
	      'span',
	      {
	        key: 'line-' + i,
	        className: 'react-syntax-highlighter-line-number',
	        style: typeof style === 'function' ? style(number) : style
	      },
	      number + '\n'
	    );
	  });
	}
	
	function LineNumbers(_ref2) {
	  var codeString = _ref2.codeString,
	      codeStyle = _ref2.codeStyle,
	      _ref2$containerStyle = _ref2.containerStyle,
	      containerStyle = _ref2$containerStyle === undefined ? { float: 'left', paddingRight: '10px' } : _ref2$containerStyle,
	      _ref2$numberStyle = _ref2.numberStyle,
	      numberStyle = _ref2$numberStyle === undefined ? {} : _ref2$numberStyle,
	      startingLineNumber = _ref2.startingLineNumber;
	
	  return _react2.default.createElement(
	    'code',
	    { style: (0, _assign2.default)({}, codeStyle, containerStyle) },
	    getLineNumbers({
	      lines: codeString.replace(/\n$/, '').split('\n'),
	      style: numberStyle,
	      startingLineNumber: startingLineNumber
	    })
	  );
	}
	
	function createLineElement(_ref3) {
	  var children = _ref3.children,
	      lineNumber = _ref3.lineNumber,
	      lineProps = _ref3.lineProps,
	      _ref3$className = _ref3.className,
	      className = _ref3$className === undefined ? [] : _ref3$className;
	
	  var properties = (typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps) || {};
	  properties.className = properties.className ? className.concat(properties.className) : className;
	  return {
	    type: 'element',
	    tagName: 'span',
	    properties: properties,
	    children: children
	  };
	}
	
	function flattenCodeTree(tree) {
	  var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var newTree = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	  for (var i = 0; i < tree.length; i++) {
	    var node = tree[i];
	    if (node.type === 'text') {
	      newTree.push(createLineElement({
	        children: [node],
	        className: className
	      }));
	    } else if (node.children) {
	      var classNames = className.concat(node.properties.className);
	      newTree = newTree.concat(flattenCodeTree(node.children, classNames));
	    }
	  }
	  return newTree;
	}
	
	function wrapLinesInSpan(codeTree, lineProps) {
	  var tree = flattenCodeTree(codeTree.value);
	  var newTree = [];
	  var lastLineBreakIndex = -1;
	  var index = 0;
	
	  var _loop = function _loop() {
	    var node = tree[index];
	    var value = node.children[0].value;
	    var newLines = getNewLines(value);
	    if (newLines) {
	      var splitValue = value.split('\n');
	      splitValue.forEach(function (text, i) {
	        var lineNumber = newTree.length + 1;
	        var newChild = { type: 'text', value: text + '\n' };
	        if (i === 0) {
	          var _children = tree.slice(lastLineBreakIndex + 1, index).concat(createLineElement({ children: [newChild], className: node.properties.className }));
	          newTree.push(createLineElement({ children: _children, lineNumber: lineNumber, lineProps: lineProps }));
	        } else if (i === splitValue.length - 1) {
	          var stringChild = tree[index + 1] && tree[index + 1].children && tree[index + 1].children[0];
	          if (stringChild) {
	            var lastLineInPreviousSpan = { type: 'text', value: '' + text };
	            var newElem = createLineElement({ children: [lastLineInPreviousSpan], className: node.properties.className });
	            tree.splice(index + 1, 0, newElem);
	          } else {
	            newTree.push(createLineElement({ children: [newChild], lineNumber: lineNumber, lineProps: lineProps }));
	          }
	        } else {
	          newTree.push(createLineElement({ children: [newChild], lineNumber: lineNumber, lineProps: lineProps }));
	        }
	      });
	      lastLineBreakIndex = index;
	    }
	    index++;
	  };
	
	  while (index < tree.length) {
	    _loop();
	  }
	  if (lastLineBreakIndex !== tree.length - 1) {
	    var children = tree.slice(lastLineBreakIndex + 1, tree.length);
	    if (children && children.length) {
	      newTree.push(createLineElement({ children: children, lineNumber: newTree.length + 1, lineProps: lineProps }));
	    }
	  }
	  return newTree;
	}
	
	function defaultRenderer(_ref4) {
	  var rows = _ref4.rows,
	      stylesheet = _ref4.stylesheet,
	      useInlineStyles = _ref4.useInlineStyles;
	
	  return rows.map(function (node, i) {
	    return (0, _createElement2.default)({
	      node: node,
	      stylesheet: stylesheet,
	      useInlineStyles: useInlineStyles,
	      key: 'code-segement' + i
	    });
	  });
	}
	
	function getCodeTree(_ref5) {
	  var astGenerator = _ref5.astGenerator,
	      language = _ref5.language,
	      code = _ref5.code,
	      defaultCodeValue = _ref5.defaultCodeValue;
	
	  if (astGenerator.getLanguage) {
	    var hasLanguage = language && astGenerator.getLanguage(language);
	    if (language === 'text') {
	      return { value: defaultCodeValue, language: 'text' };
	    } else if (hasLanguage) {
	      return astGenerator.highlight(language, code);
	    } else {
	      return astGenerator.highlightAuto(code);
	    }
	  }
	  try {
	    return language && language !== 'text' ? { value: astGenerator.highlight(code, language) } : { value: defaultCodeValue };
	  } catch (e) {
	    return { value: defaultCodeValue };
	  }
	}

/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _javascript = __webpack_require__(317);
	
	var _javascript2 = _interopRequireDefault(_javascript);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _javascript2.default;

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.registerLanguage = undefined;
	
	var _highlight = __webpack_require__(414);
	
	var _highlight2 = _interopRequireDefault(_highlight);
	
	var _core = __webpack_require__(325);
	
	var _core2 = _interopRequireDefault(_core);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var registerLanguage = exports.registerLanguage = _core2.default.registerLanguage;
	exports.default = (0, _highlight2.default)(_core2.default, {});

/***/ }),

/***/ 417:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    "hljs": {
	        "display": "block",
	        "overflowX": "auto",
	        "padding": "0.5em",
	        "color": "#000",
	        "background": "#f8f8ff"
	    },
	    "hljs-comment": {
	        "color": "#408080",
	        "fontStyle": "italic"
	    },
	    "hljs-quote": {
	        "color": "#408080",
	        "fontStyle": "italic"
	    },
	    "hljs-keyword": {
	        "color": "#954121"
	    },
	    "hljs-selector-tag": {
	        "color": "#954121"
	    },
	    "hljs-literal": {
	        "color": "#954121"
	    },
	    "hljs-subst": {
	        "color": "#954121"
	    },
	    "hljs-number": {
	        "color": "#40a070"
	    },
	    "hljs-string": {
	        "color": "#219161"
	    },
	    "hljs-doctag": {
	        "color": "#219161"
	    },
	    "hljs-selector-id": {
	        "color": "#19469d"
	    },
	    "hljs-selector-class": {
	        "color": "#19469d"
	    },
	    "hljs-section": {
	        "color": "#19469d"
	    },
	    "hljs-type": {
	        "color": "#19469d"
	    },
	    "hljs-params": {
	        "color": "#00f"
	    },
	    "hljs-title": {
	        "color": "#458",
	        "fontWeight": "bold"
	    },
	    "hljs-tag": {
	        "color": "#000080",
	        "fontWeight": "normal"
	    },
	    "hljs-name": {
	        "color": "#000080",
	        "fontWeight": "normal"
	    },
	    "hljs-attribute": {
	        "color": "#000080",
	        "fontWeight": "normal"
	    },
	    "hljs-variable": {
	        "color": "#008080"
	    },
	    "hljs-template-variable": {
	        "color": "#008080"
	    },
	    "hljs-regexp": {
	        "color": "#b68"
	    },
	    "hljs-link": {
	        "color": "#b68"
	    },
	    "hljs-symbol": {
	        "color": "#990073"
	    },
	    "hljs-bullet": {
	        "color": "#990073"
	    },
	    "hljs-built_in": {
	        "color": "#0086b3"
	    },
	    "hljs-builtin-name": {
	        "color": "#0086b3"
	    },
	    "hljs-meta": {
	        "color": "#999",
	        "fontWeight": "bold"
	    },
	    "hljs-deletion": {
	        "background": "#fdd"
	    },
	    "hljs-addition": {
	        "background": "#dfd"
	    },
	    "hljs-emphasis": {
	        "fontStyle": "italic"
	    },
	    "hljs-strong": {
	        "fontWeight": "bold"
	    }
	};

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _distanceBetweenPoints = __webpack_require__(439);
	
	var _distanceBetweenPoints2 = _interopRequireDefault(_distanceBetweenPoints);
	
	var _Point = __webpack_require__(124);
	
	var _Point2 = _interopRequireDefault(_Point);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Gradient = function () {
	  function Gradient(_ref) {
	    var initial = _ref.initial,
	        end = _ref.end,
	        width = _ref.width,
	        height = _ref.height,
	        jumps = _ref.jumps;
	
	    _classCallCheck(this, Gradient);
	
	    this.jumps = jumps;
	    this.cache = {};
	
	    var widthInTriangles = Math.ceil(width / jumps);
	    var heightInTriangles = Math.ceil(height / jumps);
	    var radial = Math.round(Math.sqrt(widthInTriangles * widthInTriangles + heightInTriangles * heightInTriangles));
	
	    var colors = [];
	    var i = void 0;
	
	    this.center = new _Point2.default(widthInTriangles / 2, heightInTriangles / 2 - 1.5);
	
	    // If there are more colors than triangles
	    if (radial / 2 + 1 < end - initial) {
	      while (radial / 2 + 1 < end - initial) {
	        end--;
	        if (radial / 2 + 1 < end - initial) {
	          initial++;
	        }
	      }
	
	      for (i = initial; i < end; i++) {
	        colors.push(i);
	      }
	      // there are more triangles than colors
	    } else {
	      for (i = initial; i < end; i++) {
	        colors.push(i);
	      }
	
	      while (colors.length < Math.ceil(radial / 2)) {
	        colors.push(colors[Math.floor(Math.random() * 8)]);
	      }
	    }
	    colors.sort(function (a, b) {
	      return a - b;
	    }).reverse();
	
	    this.colors = colors;
	  }
	
	  _createClass(Gradient, [{
	    key: 'randomGray',
	    value: function randomGray(x, y) {
	      var jumps = this.jumps,
	          center = this.center,
	          colors = this.colors,
	          cache = this.cache;
	
	
	      var spaceX = x / jumps;
	      var spaceY = y / jumps;
	      var distFromCenter = cache[x] && cache[x][y] || Math.floor((0, _distanceBetweenPoints2.default)(center, new _Point2.default(spaceX, spaceY)));
	      var color = colors[distFromCenter] || colors[colors.length + 1];
	      var random = 0;
	
	      if (!cache[x]) {
	        cache[x] = {};
	      }
	
	      if (!cache[x][y]) {
	        cache[x][y] = distFromCenter;
	      }
	
	      if (distFromCenter > colors.length * 0.7) {
	        random = Math.ceil(Math.random() * 2) * (Math.random() < 0.5 ? -1 : 1) * 1;
	      } else if (distFromCenter > colors.length * 0.6) {
	        random = Math.ceil(Math.random() * 2) * (Math.random() < 0.5 ? -1 : 1) * 2;
	      } else if (distFromCenter > colors.length * 0.4) {
	        random = Math.ceil(Math.random() * 2) * (Math.random() < 0.5 ? -1 : 1) * 3;
	      } else if (distFromCenter > colors.length * 0.2) {
	        random = Math.ceil(Math.random() * 2) * (Math.random() < 0.5 ? -1 : 1) * 2;
	      } else {
	        random = Math.ceil(Math.random() * 2) * (Math.random() < 0.5 ? -1 : 1) * 1;
	      }
	
	      color += random;
	
	      return 'rgb(' + [color, color, color].join(',') + ')';
	    }
	  }, {
	    key: 'setCenter',
	    value: function setCenter(x, y) {
	      this.center = new _Point2.default(x / this.jumps, y / this.jumps);
	      this.cache = {};
	    }
	  }]);
	
	  return Gradient;
	}();
	
	exports.default = Gradient;

/***/ }),

/***/ 124:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Point = function Point(x, y) {
	  _classCallCheck(this, Point);
	
	  this.x = x;
	  this.y = y;
	};
	
	exports.default = Point;

/***/ }),

/***/ 436:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Rectangle = function () {
	  function Rectangle(_ref) {
	    var width = _ref.width,
	        height = _ref.height,
	        color = _ref.color;
	
	    _classCallCheck(this, Rectangle);
	
	    this.width = width;
	    this.height = height;
	    this.color = color;
	  }
	
	  _createClass(Rectangle, [{
	    key: "draw",
	    value: function draw(ctx) {
	      ctx.fillStyle = this.color;
	      ctx.fillRect(0, 0, this.width, this.height);
	    }
	  }]);
	
	  return Rectangle;
	}();
	
	exports.default = Rectangle;

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Point = __webpack_require__(124);
	
	var _Point2 = _interopRequireDefault(_Point);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Triangle = function () {
	  function Triangle(_ref) {
	    var initialPoint = _ref.initialPoint,
	        width = _ref.width,
	        gradient = _ref.gradient,
	        darkColor = _ref.darkColor,
	        lightColor = _ref.lightColor;
	
	    _classCallCheck(this, Triangle);
	
	    this.initialPoint = initialPoint;
	    this.width = width;
	    this.gradient = gradient;
	    this.darkColor = darkColor;
	    this.lightColor = lightColor;
	    this.color = gradient.randomGray(initialPoint.x, initialPoint.y);
	    this.getPoints();
	  }
	
	  _createClass(Triangle, [{
	    key: 'getPoints',
	    value: function getPoints() {
	      var initialPoint = this.initialPoint,
	          width = this.width;
	
	      var points = [];
	
	      switch (this.type) {
	        case 1:
	          points.push(initialPoint);
	          points.push(new _Point2.default(initialPoint.x + width, initialPoint.y));
	          points.push(new _Point2.default(initialPoint.x, initialPoint.y + width));
	          break;
	        case 2:
	          points.push(new _Point2.default(initialPoint.x, initialPoint.y + width));
	          points.push(new _Point2.default(points[0].x + width, points[0].y - width));
	          points.push(new _Point2.default(points[0].x + width, points[0].y));
	          break;
	        case 3:
	          points.push(initialPoint);
	          points.push(new _Point2.default(initialPoint.x + width, initialPoint.y + width));
	          points.push(new _Point2.default(initialPoint.x + width, initialPoint.y));
	          break;
	        default:
	          points.push(initialPoint);
	          points.push(new _Point2.default(initialPoint.x, initialPoint.y + width));
	          points.push(new _Point2.default(initialPoint.x + width, initialPoint.y));
	          break;
	      }
	
	      this.points = points;
	      return points;
	    }
	  }, {
	    key: 'draw',
	    value: function draw(ctx) {
	      var color = this.color,
	          points = this.points;
	
	      ctx.fillStyle = color;
	      if (color.toString().indexOf('NaN') >= 0) {
	        return;
	      }
	      ctx.beginPath();
	      ctx.moveTo(points[0].x, points[0].y);
	      ctx.lineTo(points[1].x, points[1].y);
	      ctx.lineTo(points[2].x, points[2].y);
	      ctx.lineTo(points[0].x, points[0].y);
	      ctx.closePath();
	      ctx.fill();
	      return this;
	    }
	  }, {
	    key: 'redraw',
	    value: function redraw(ctx) {
	      var colored = this.colored,
	          initialPoint = this.initialPoint,
	          darkColor = this.darkColor,
	          lightColor = this.lightColor,
	          width = this.width;
	
	
	      this.type = Math.floor(Math.random() * 4);
	      var points = this.getPoints();
	
	      if (colored) {
	        switch (this.type) {
	          case 1:
	            points.push(initialPoint);
	            points.push(new _Point2.default(initialPoint.x + width, initialPoint.y));
	            points.push(new _Point2.default(initialPoint.x, initialPoint.y + width));
	            break;
	          case 2:
	            points.push(new _Point2.default(initialPoint.x, initialPoint.y + width));
	            points.push(new _Point2.default(points[0].x + width, points[0].y - width));
	            points.push(new _Point2.default(points[0].x + width, points[0].y));
	            break;
	          case 3:
	            points.push(initialPoint);
	            points.push(new _Point2.default(initialPoint.x + width, initialPoint.y + width));
	            points.push(new _Point2.default(initialPoint.x + width, initialPoint.y));
	            break;
	          default:
	            points.push(initialPoint);
	            points.push(new _Point2.default(initialPoint.x, initialPoint.y + width));
	            points.push(new _Point2.default(initialPoint.x + width, initialPoint.y));
	            break;
	        }
	        this.color = ctx.createLinearGradient(initialPoint.x, initialPoint.y, initialPoint.x + width, initialPoint.y + width);
	        this.color.addColorStop(0, darkColor);
	        this.color.addColorStop(1, lightColor);
	      } else {
	        this.color = this.gradient.randomGray(initialPoint.x, initialPoint.y);
	      }
	
	      return this.draw(ctx);
	    }
	  }, {
	    key: 'init',
	    value: function init(ctx) {
	      var initialPoint = this.initialPoint,
	          gradient = this.gradient;
	
	      var types = [1, 2, 3, 4];
	
	      while (types.length > 1) {
	        this.type = types.splice(Math.floor(Math.random() * types.length), 1)[0];
	        this.color = gradient.randomGray(initialPoint.x, initialPoint.y);
	        this.getPoints();
	        this.draw(ctx);
	      }
	
	      this.color = gradient.randomGray(initialPoint.x, initialPoint.y);
	      this.type = types.pop();
	      this.getPoints();
	
	      this.draw(ctx);
	
	      return this;
	    }
	  }, {
	    key: 'colorRedraw',
	    value: function colorRedraw() {
	      this.colored = true;
	      return this;
	    }
	  }, {
	    key: 'grayRedraw',
	    value: function grayRedraw(ctx) {
	      this.colored = false;
	      this.init(ctx);
	      return this.init(ctx);
	    }
	  }]);
	
	  return Triangle;
	}();
	
	exports.default = Triangle;

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Triangles;
	
	var _lodash = __webpack_require__(324);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _Point = __webpack_require__(124);
	
	var _Point2 = _interopRequireDefault(_Point);
	
	var _Rectangle = __webpack_require__(436);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _Triangle = __webpack_require__(437);
	
	var _Triangle2 = _interopRequireDefault(_Triangle);
	
	var _Gradient = __webpack_require__(435);
	
	var _Gradient2 = _interopRequireDefault(_Gradient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Triangles(_ref) {
	  var id = _ref.id,
	      cb = _ref.cb,
	      _ref$dark = _ref.dark,
	      dark = _ref$dark === undefined ? 20 : _ref$dark,
	      _ref$light = _ref.light,
	      light = _ref$light === undefined ? 45 : _ref$light,
	      _ref$darkColor = _ref.darkColor,
	      darkColor = _ref$darkColor === undefined ? 'rgba(255, 122, 5, 0.3)' : _ref$darkColor,
	      _ref$lightColor = _ref.lightColor,
	      lightColor = _ref$lightColor === undefined ? 'rgba(246, 90, 90, 0.3)' : _ref$lightColor,
	      _ref$size = _ref.size,
	      size = _ref$size === undefined ? 25 : _ref$size,
	      _ref$refreshTime = _ref.refreshTime,
	      refreshTime = _ref$refreshTime === undefined ? 50 : _ref$refreshTime;
	
	  var canvas = document.getElementById(id);
	  var container = canvas.parentNode;
	
	  var calledCallback = false;
	  var triangles = void 0,
	      ctx = void 0,
	      width = void 0,
	      height = void 0,
	      i = void 0,
	      j = void 0,
	      gradient = void 0,
	      paintInterval = void 0;
	
	  var paint = function paint() {
	    triangles = {};
	
	    if (paintInterval) {
	      clearInterval(paintInterval);
	    }
	
	    gradient = new _Gradient2.default({ initial: dark, end: light, width: width, height: height, jumps: size });
	
	    ctx = canvas.getContext('2d');
	    new _Rectangle2.default({ width: width, height: height, color: 'rgb(' + [light, light, light].join(',') + ')' }).draw(ctx);
	
	    for (i = 0; i < width / size + size; i++) {
	      triangles[i] = {};
	      for (j = 0; j < height / size + size; j++) {
	        triangles[i][j] = new _Triangle2.default({
	          initialPoint: new _Point2.default(i * size, j * size),
	          width: size,
	          gradient: gradient,
	          darkColor: darkColor,
	          lightColor: lightColor
	        }).init(ctx);
	      }
	    }
	
	    paintInterval = setInterval(function () {
	      for (i = 0; i < width * 0.2 / size; i++) {
	        for (j = 0; j < height * 0.2 / size; j++) {
	          triangles[Math.floor(Math.random() * width / size)][Math.floor(Math.random() * height / size)].redraw(ctx);
	        }
	      }
	    }, refreshTime);
	  };
	
	  var resize = (0, _lodash2.default)(function () {
	    canvas.setAttribute('width', width = container.clientWidth);
	    canvas.setAttribute('height', height = container.clientHeight);
	    paint();
	
	    if (!calledCallback && typeof cb === 'function') {
	      calledCallback = true;
	      cb();
	    }
	  }, 100);
	
	  resize();
	
	  canvas.addEventListener('mousemove', function (evt) {
	    var rect = canvas.getBoundingClientRect();
	    var interval = void 0;
	    var toRedraw = [];
	
	    var mousePos = new _Point2.default(Math.floor((evt.clientX - rect.left) / size), Math.floor((evt.clientY - rect.top) / size));
	    toRedraw.push(triangles[mousePos.x][mousePos.y].colorRedraw());
	
	    if (triangles[mousePos.x + 1] && triangles[mousePos.x + 1][mousePos.y + 1]) {
	      toRedraw.push(triangles[mousePos.x + 1][mousePos.y + 1].colorRedraw());
	    }
	
	    if (triangles[mousePos.x - 1] && triangles[mousePos.x - 1][mousePos.y + 1]) {
	      toRedraw.push(triangles[mousePos.x - 1][mousePos.y + 1].colorRedraw());
	    }
	
	    if (triangles[mousePos.x + 1] && triangles[mousePos.x + 1][mousePos.y - 1]) {
	      toRedraw.push(triangles[mousePos.x + 1][mousePos.y - 1].colorRedraw());
	    }
	
	    if (triangles[mousePos.x - 1] && triangles[mousePos.x - 1][mousePos.y - 1]) {
	      toRedraw.push(triangles[mousePos.x - 1][mousePos.y - 1].colorRedraw());
	    }
	
	    if (triangles[mousePos.x][mousePos.y + 1]) {
	      toRedraw.push(triangles[mousePos.x][mousePos.y + 1].colorRedraw());
	    }
	
	    if (triangles[mousePos.x][mousePos.y - 1]) {
	      toRedraw.push(triangles[mousePos.x][mousePos.y - 1].colorRedraw());
	    }
	
	    if (triangles[mousePos.x][mousePos.y - 1]) {
	      toRedraw.push(triangles[mousePos.x][mousePos.y - 1].colorRedraw());
	    }
	
	    if (triangles[mousePos.x][mousePos.y + 1]) {
	      toRedraw.push(triangles[mousePos.x][mousePos.y + 1].colorRedraw());
	    }
	
	    interval = function () {
	      return setInterval(function () {
	        toRedraw[Math.floor(Math.random() * toRedraw.length)].redraw(ctx);
	      }, 200);
	    }();
	
	    setTimeout(function () {
	      clearInterval(interval);
	      while (toRedraw.length > 0) {
	        toRedraw.pop().grayRedraw(ctx);
	      }
	    }, 1000);
	  }, false);
	
	  if (window.attachEvent) {
	    window.attachEvent('onresize', resize);
	  } else if (window.addEventListener) {
	    window.addEventListener('resize', resize, true);
	  }
	}

/***/ }),

/***/ 439:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = distance;
	function distance(pointA, pointB) {
	  var xA = pointA.x,
	      yA = pointA.y;
	  var xB = pointB.x,
	      yB = pointB.y;
	
	  var xs = Math.pow(xB - xA, 2);
	  var ys = Math.pow(yB - yA, 2);
	  return Math.sqrt(xs + ys);
	}


/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(157);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _trianglesCanvas = __webpack_require__(438);
	
	var _trianglesCanvas2 = _interopRequireDefault(_trianglesCanvas);
	
	var _light = __webpack_require__(416);
	
	var _light2 = _interopRequireDefault(_light);
	
	var _javascript = __webpack_require__(415);
	
	var _javascript2 = _interopRequireDefault(_javascript);
	
	var _docco = __webpack_require__(417);
	
	var _docco2 = _interopRequireDefault(_docco);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _light.registerLanguage)("javascript", _javascript2.default);
	
	var IndexPage = function (_Component) {
	  _inherits(IndexPage, _Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  IndexPage.prototype.componentDidMount = function componentDidMount() {
	    (0, _trianglesCanvas2.default)({ id: "triangles" });
	    (0, _trianglesCanvas2.default)({ id: "triangles2", dark: 200, light: 220 });
	    (0, _trianglesCanvas2.default)({
	      id: "triangles3",
	      darkColor: "#69bfa5",
	      lightColor: "#48796b"
	    });
	    (0, _trianglesCanvas2.default)({ id: "trianglesSquares", size: 10 });
	    (0, _trianglesCanvas2.default)({ id: "trianglesSquares2", size: 40 });
	  };
	
	  IndexPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "p",
	        null,
	        "Default values:"
	      ),
	      _react2.default.createElement(
	        _light2.default,
	        { style: _docco2.default, language: "javascript" },
	        "npm i triangles-canvas\n\nimport trianglesCanvas from 'triangles-canvas'\ntrianglesCanvas({\n  id, // the id where the canvas should be drawn\n  cb, // a callback to be run when the rendering is done\n  dark = 20, // darkest color in rgba\n  light = 45, // lightest color in rgba\n  darkColor = 'rgba(255, 122, 5, 0.3)', // darkest color to be highlighted when mousemove\n  lightColor = 'rgba(246, 90, 90, 0.3)', // lightest color to be highlighted when mousemove\n  size = 25, // amount of squares to be drawn on the canvas (in px)\n  refreshTime = 50 // time in ms to draw each set of triangles\n})"
	      ),
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "p",
	        null,
	        "An npm module to have a background with animated triangles using canvas. Recomputes the gradient while resizing."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Also, move your mouse over it!."
	      ),
	      _react2.default.createElement(
	        _light2.default,
	        { style: _docco2.default, language: "javascript" },
	        "Triangles({ id: 'triangles' })"
	      ),
	      _react2.default.createElement(
	        "div",
	        { style: { width: "100%", height: 400 } },
	        _react2.default.createElement("canvas", { id: "triangles" })
	      ),
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "p",
	        null,
	        "You can specify the size of the squares."
	      ),
	      _react2.default.createElement(
	        _light2.default,
	        { style: _docco2.default, language: "javascript" },
	        "Triangles({ id: 'trianglesSquares', size: 10 })\nTriangles({ id: 'trianglesSquares2', size: 40 })"
	      ),
	      _react2.default.createElement(
	        "div",
	        { style: { width: "100%", height: 400 } },
	        _react2.default.createElement("canvas", { id: "trianglesSquares" })
	      ),
	      _react2.default.createElement(
	        "div",
	        { style: { width: "100%", height: 400 } },
	        _react2.default.createElement("canvas", { id: "trianglesSquares2" })
	      ),
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "p",
	        null,
	        "You can specify starting color or ending color for the background."
	      ),
	      _react2.default.createElement(
	        _light2.default,
	        { style: _docco2.default, language: "javascript" },
	        "Triangles({ id: 'triangles2', dark: 200, light: 220 })"
	      ),
	      _react2.default.createElement(
	        "div",
	        { style: { width: "100%", height: 400 } },
	        _react2.default.createElement("canvas", { id: "triangles2" })
	      ),
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Or change the highlighted color."
	      ),
	      _react2.default.createElement(
	        _light2.default,
	        { style: _docco2.default, language: "javascript" },
	        "Triangles({ id: 'triangles3', darkColor: '#69bfa5', lightColor: '#48796b' })"
	      ),
	      _react2.default.createElement(
	        "div",
	        { style: { width: "100%", height: 400 } },
	        _react2.default.createElement("canvas", { id: "triangles3" })
	      )
	    );
	  };
	
	  return IndexPage;
	}(_react.Component);
	
	exports.default = IndexPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-e83ab58bc2db39ecf3fa.js